/* Neeta Lulla — product page behaviour. One IIFE per product-hero instance on the page
   (in practice always one), guarded so re-running (theme editor re-renders) is safe. */
(function(){

  document.querySelectorAll('[data-nl-product-root]').forEach(function(root){
    if (root.dataset.nlProdInit) return;
    root.dataset.nlProdInit = '1';
    initProduct(root);
  });

  function initProduct(root){
    var dataEl = root.querySelector('[data-nl-product-json]');
    if (!dataEl) return;
    var pdata;
    try { pdata = JSON.parse(dataEl.textContent); } catch(e){ return; }

    var variants = pdata.variants;              // [{id, available, qty, price, compareAt, options:[v1,v2,...], imagePos}]
    var optionNames = pdata.optionNames;         // ["Color","Size"]
    var currencyIsInr = pdata.currencyIsInr;

    // ---------- money formatting (Indian lakh grouping to match the rest of the site) ----------
    function formatMoney(cents){
      if (!currencyIsInr) {
        // Fallback: simple formatting using the shop's money_format is done server-side for the
        // initial render; for JS-driven updates on non-INR shops we still show a readable number.
        return '₹' + (cents/100).toFixed(2);
      }
      var rupees = Math.floor(cents/100);
      var paise = cents % 100;
      var s = String(rupees);
      var out = s;
      if (s.length > 3) {
        var head = s.slice(0, s.length-3);
        out = s.slice(-3);
        var parts = [];
        while (head.length > 2) { parts.unshift(head.slice(-2)); head = head.slice(0, -2); }
        if (head.length) parts.unshift(head);
        out = parts.join(',') + ',' + out;
      }
      var str = '₹' + out;
      if (paise > 0) str += '.' + (paise < 10 ? '0' + paise : paise);
      return str;
    }

    // ---------- current selection ----------
    var selected = pdata.initialSelection.slice(); // array of currently chosen option values, by index

    function variantFor(sel){
      for (var i=0;i<variants.length;i++){
        var v = variants[i], match = true;
        for (var j=0;j<sel.length;j++){ if (v.options[j] !== sel[j]) { match = false; break; } }
        if (match) return v;
      }
      return null;
    }

    // Which variants exist for a given option index/value, holding the OTHER selected values fixed —
    // used to grey out / MTO-badge size chips (or swatches) based on real inventory of the current combo.
    function variantForCombo(idx, value){
      var sel = selected.slice();
      sel[idx] = value;
      return variantFor(sel);
    }

    function statusFor(v){
      if (!v) return 'missing';
      if (!v.available) return 'soldout';
      if (v.qty > 0) return 'instock';
      return 'mto'; // available for sale with 0 tracked stock -> continue-selling-when-out-of-stock = made to order
    }

    // ---------- DOM refs ----------
    var priceNow = root.querySelector('[data-nl-price-now]');
    var priceWas = root.querySelector('[data-nl-price-was]');
    var priceNote = root.querySelector('[data-nl-price-note]');
    var stockBadge = root.querySelector('[data-nl-stock-badge]');
    var addBtn = root.querySelector('[data-nl-add-to-cart]');
    var stickyAddBtn = root.querySelector('[data-nl-sticky-add]');
    var stickyBar = root.querySelector('[data-nl-sticky-bar]');
    var sbName = root.querySelector('[data-nl-sb-name]');
    var sbPrice = root.querySelector('[data-nl-sb-price]');
    var stageBadge = root.querySelector('[data-nl-stage-badge]');
    var mtoLabel = pdata.mtoLabel || 'Made to Order';
    var rtsLabel = pdata.rtsLabel || 'Ships Fast';
    var mtoNote = pdata.mtoNote || 'Made to order — please allow 8–10 weeks for delivery, tailored to your measurements.';
    var rtsNote = pdata.rtsNote || 'In stock — ships within 2–4 working days from our Mumbai atelier.';
    var soldOutNote = pdata.soldOutNote || 'This size is currently sold out.';

    function updateOptionGroupsAvailability(){
      root.querySelectorAll('[data-nl-opt-input]').forEach(function(input){
        var idx = parseInt(input.dataset.nlOptIndex, 10);
        var val = input.value;
        var v = variantForCombo(idx, val);
        var st = statusFor(v);
        var wrap = input.closest('[data-nl-opt-wrap]');
        if (!wrap) return;
        wrap.classList.toggle('unavailable', st === 'soldout' || st === 'missing');
        wrap.classList.toggle('mto', st === 'mto');
      });
    }

    function updateUI(){
      var v = variantFor(selected);
      updateOptionGroupsAvailability();

      root.querySelectorAll('[data-nl-opt-input]').forEach(function(input){
        var idx = parseInt(input.dataset.nlOptIndex, 10);
        var wrap = input.closest('[data-nl-opt-wrap]');
        var isActive = selected[idx] === input.value;
        input.checked = isActive;
        if (wrap) wrap.classList.toggle('active', isActive);
      });
      root.querySelectorAll('[data-nl-opt-value-display]').forEach(function(el){
        var idx = parseInt(el.dataset.nlOptValueDisplay, 10);
        el.textContent = selected[idx] || '';
      });

      var st = statusFor(v);
      if (v) {
        if (priceNow) priceNow.textContent = formatMoney(v.price);
        if (priceWas) {
          if (v.compareAt && v.compareAt > v.price) { priceWas.textContent = formatMoney(v.compareAt); priceWas.hidden = false; }
          else priceWas.hidden = true;
        }
        if (sbPrice) sbPrice.textContent = formatMoney(v.price);
      }

      var note = st === 'mto' ? mtoNote : (st === 'soldout' ? soldOutNote : rtsNote);
      if (priceNote) priceNote.textContent = st === 'mto' ? (pdata.mtoTaxNote || note) : (pdata.rtsTaxNote || note);
      if (root.querySelector('[data-nl-size-hint]')) root.querySelector('[data-nl-size-hint]').textContent = note;

      /* "Made to Order" / "Ships Fast" labels are no longer shown; only a plain "Sold Out" marker remains. */
      if (stockBadge) {
        stockBadge.classList.remove('is-mto');
        stockBadge.textContent = st === 'soldout' ? 'Sold Out' : '';
        stockBadge.hidden = st !== 'soldout';
      }
      if (stageBadge) {
        stageBadge.classList.remove('is-mto');
        stageBadge.textContent = st === 'soldout' ? 'Sold Out' : '';
        stageBadge.style.display = st === 'soldout' ? '' : 'none';
      }

      var canAdd = !!v && v.available;
      [addBtn, stickyAddBtn].forEach(function(btn){
        if (!btn) return;
        btn.disabled = !canAdd;
        btn.dataset.variantId = v ? v.id : '';
      });
      if (sbName) sbName.textContent = pdata.title + (selected.length ? ' — ' + selected.join(' / ') : '');

      markCurrentSizeRow();
      root.dataset.nlCurrentVariant = v ? v.id : '';
    }

    root.addEventListener('change', function(e){
      var input = e.target.closest('[data-nl-opt-input]');
      if (!input) return;
      var idx = parseInt(input.dataset.nlOptIndex, 10);
      selected[idx] = input.value;
      updateUI();
    });

    updateUI();

    // ---------- gallery ----------
    var track = root.querySelector('[data-nl-stage-track]');
    var thumbs = root.querySelectorAll('[data-nl-thumb]');
    var countEl = root.querySelector('[data-nl-stage-count]');
    var slideCount = thumbs.length;
    var current = 0;
    function pad(n){ return n < 10 ? '0' + n : '' + n; }
    function goTo(i){
      if (!slideCount) return;
      current = (i + slideCount) % slideCount;
      if (track) track.style.transform = 'translateX(-' + (current*100) + '%)';
      thumbs.forEach(function(t, idx){ t.classList.toggle('active', idx === current); });
      if (countEl) countEl.textContent = pad(current+1) + ' / ' + pad(slideCount);
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ goTo(parseInt(t.dataset.index, 10)); }); });
    var prevBtn = root.querySelector('[data-nl-stage-prev]');
    var nextBtn = root.querySelector('[data-nl-stage-next]');
    if (prevBtn) prevBtn.addEventListener('click', function(){ goTo(current-1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ goTo(current+1); });

    // ---------- wishlist (shared storage key with the collection page) ----------
    function readWishlist(){ try { return JSON.parse(localStorage.getItem('nlcWishlist') || '[]'); } catch(e){ return []; } }
    function writeWishlist(list){ try { localStorage.setItem('nlcWishlist', JSON.stringify(list)); } catch(e){} }
    function syncWishButtons(){
      var list = readWishlist();
      var active = list.indexOf(pdata.handle) !== -1;
      root.querySelectorAll('[data-nl-wish-toggle]').forEach(function(b){ b.classList.toggle('active', active); });
    }
    root.querySelectorAll('[data-nl-wish-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var list = readWishlist();
        var i = list.indexOf(pdata.handle);
        if (i === -1) list.push(pdata.handle); else list.splice(i, 1);
        writeWishlist(list);
        syncWishButtons();
      });
    });
    syncWishButtons();

    // ---------- quantity ----------
    var qty = 1;
    var qtyVal = root.querySelector('[data-nl-qty-val]');
    var qtyMinus = root.querySelector('[data-nl-qty-minus]');
    var qtyPlus = root.querySelector('[data-nl-qty-plus]');
    function setQty(n){ qty = Math.max(1, Math.min(10, n)); if (qtyVal) qtyVal.textContent = qty; }
    if (qtyMinus) qtyMinus.addEventListener('click', function(){ setQty(qty-1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(){ setQty(qty+1); });

    // ---------- add to cart ----------
    function updateBagCount(count){
      document.querySelectorAll('.bag-count').forEach(function(el){ el.textContent = count; });
    }
    function addToCart(btn){
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var original = btn.innerHTML;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        updateBagCount(cart.item_count);
        btn.textContent = 'Added ✓';
        setTimeout(function(){ btn.innerHTML = original; btn.disabled = false; }, 1400);
      })
      .catch(function(){
        btn.textContent = 'Try Again';
        setTimeout(function(){ btn.innerHTML = original; btn.disabled = false; }, 1400);
      });
    }
    if (addBtn) addBtn.addEventListener('click', function(){ addToCart(addBtn); });
    if (stickyAddBtn) stickyAddBtn.addEventListener('click', function(){ addToCart(stickyAddBtn); });

    // ---------- size guide modal ----------
    var sizeModalOverlay = root.querySelector('[data-nl-size-modal]');
    var sizeTable = root.querySelector('[data-nl-size-table]');
    var unitNote = root.querySelector('[data-nl-unit-note]');
    function currentSizeValue(){
      var sizeIdx = optionNames.findIndex(function(n){ return n.toLowerCase() === 'size'; });
      return sizeIdx > -1 ? selected[sizeIdx] : null;
    }
    function markCurrentSizeRow(){
      if (!sizeTable) return;
      var cur = currentSizeValue();
      sizeTable.querySelectorAll('tbody tr').forEach(function(row){
        row.classList.toggle('current', row.dataset.size === cur);
      });
    }
    function openSizeModal(){
      if (!sizeModalOverlay) return;
      sizeModalOverlay.classList.add('open');
      sizeModalOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      markCurrentSizeRow();
    }
    function closeSizeModal(){
      if (!sizeModalOverlay) return;
      sizeModalOverlay.classList.remove('open');
      sizeModalOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    var sizeChartBtn = root.querySelector('[data-nl-size-chart-open]');
    if (sizeChartBtn) sizeChartBtn.addEventListener('click', openSizeModal);
    var sizeModalClose = root.querySelector('[data-nl-size-modal-close]');
    if (sizeModalClose) sizeModalClose.addEventListener('click', closeSizeModal);
    if (sizeModalOverlay) sizeModalOverlay.addEventListener('click', function(e){ if (e.target === sizeModalOverlay) closeSizeModal(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sizeModalOverlay && sizeModalOverlay.classList.contains('open')) closeSizeModal(); });

    function selectSizeFromChart(sizeVal){
      var sizeIdx = optionNames.findIndex(function(n){ return n.toLowerCase() === 'size'; });
      if (sizeIdx === -1) return;
      var input = root.querySelector('[data-nl-opt-input][data-nl-opt-index="' + sizeIdx + '"][value="' + CSS.escape(sizeVal) + '"]');
      if (input) { selected[sizeIdx] = sizeVal; updateUI(); }
    }
    if (sizeTable) {
      sizeTable.querySelectorAll('tbody tr').forEach(function(row){
        row.addEventListener('click', function(){ selectSizeFromChart(row.dataset.size); closeSizeModal(); });
      });
    }
    function toIn(v){ return parseFloat(v); }
    function toCm(v){ return Math.round(parseFloat(v) * 2.54 * 10) / 10; }
    root.querySelectorAll('[data-nl-unit-toggle] button').forEach(function(btn){
      btn.addEventListener('click', function(){
        root.querySelectorAll('[data-nl-unit-toggle] button').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var unit = btn.dataset.unit;
        if (unitNote) unitNote.textContent = unit === 'cm' ? 'centimetres' : 'inches';
        if (sizeTable) {
          sizeTable.querySelectorAll('tbody tr').forEach(function(row){
            ['bust','waist','hip','shoulder'].forEach(function(key, i){
              var cell = row.children[i+1];
              if (!cell) return;
              var raw = row.dataset[key];
              if (raw === undefined || raw === '') { cell.textContent = '—'; return; }
              cell.textContent = unit === 'cm' ? toCm(raw) : toIn(raw);
            });
          });
        }
      });
    });

    // ---------- accordion ----------
    root.querySelectorAll('.accordion-item').forEach(function(item){
      var trigger = item.querySelector('.accordion-trigger');
      var panel = item.querySelector('.accordion-panel');
      if (!trigger || !panel) return;
      function setState(open){
        if (open) { panel.style.maxHeight = panel.scrollHeight + 'px'; item.classList.add('open'); }
        else { panel.style.maxHeight = 0; item.classList.remove('open'); }
      }
      setState(item.classList.contains('open'));
      trigger.addEventListener('click', function(){ setState(!item.classList.contains('open')); });
    });
    window.addEventListener('resize', function(){
      root.querySelectorAll('.accordion-item.open .accordion-panel').forEach(function(p){ p.style.maxHeight = p.scrollHeight + 'px'; });
    });

    // ---------- copy link ----------
    var copyBtn = root.querySelector('[data-nl-copy-link]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function(){
        var original = copyBtn.innerHTML;
        if (navigator.clipboard) navigator.clipboard.writeText(window.location.href).catch(function(){});
        copyBtn.innerHTML = '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.5"><path d="M20 6L9 17l-5-5"/></svg> Copied';
        setTimeout(function(){ copyBtn.innerHTML = original; }, 1600);
      });
    }

    // ---------- sticky mobile bar ----------
    var infoPanel = root.querySelector('[data-nl-info-panel]');
    if (stickyBar && infoPanel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ stickyBar.classList.toggle('show', !e.isIntersecting); });
      }, { rootMargin: '-200px 0px 0px 0px' });
      io.observe(infoPanel);
    }

    // ---------- recently viewed (localStorage; no app needed) ----------
    (function(){
      var KEY = 'nlRecentlyViewed';
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ list = []; }
      list = list.filter(function(p){ return p.handle !== pdata.handle; });
      list.unshift({ handle: pdata.handle, title: pdata.title, url: pdata.url, image: pdata.cardImage, price: pdata.cardPrice, priceVaries: pdata.cardPriceVaries, badge: pdata.cardBadge, badgeMto: pdata.cardBadgeMto });
      list = list.slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}

      document.querySelectorAll('[data-nl-recently-viewed]').forEach(function(target){
        var grid = target.querySelector('[data-nl-rv-grid]');
        var empty = target.querySelector('[data-nl-rv-empty]');
        if (!grid) return;
        var items = list.filter(function(p){ return p.handle !== pdata.handle; }).slice(0, parseInt(target.dataset.nlRvLimit || '6', 10));
        if (!items.length) { target.hidden = true; return; }
        target.hidden = false;
        if (empty) empty.hidden = true;
        grid.innerHTML = items.map(function(p){
          /* only a plain "Sold Out" marker is shown; "Made to Order" / "Ships Fast" are not */
          var badge = p.badge === 'Sold Out' ? '<span class="celeb-tile-badge">Sold Out</span>' : '';
          var priceHtml = (p.priceVaries ? 'from ' : '') + (p.price || '');
          return '<a class="celeb-tile" href="' + p.url + '">' +
            '<div class="celeb-tile-img">' + badge + '<img src="' + p.image + '" alt="" loading="lazy"></div>' +
            '<div class="celeb-tile-info"><div class="celeb-tile-name">' + p.title + '</div><div class="celeb-tile-price">' + priceHtml + '</div></div>' +
            '</a>';
        }).join('');
      });
    })();
  }
})();
